// Utils
export const checksum = (s: string) => {
  var chk = 0x12345678;
  var len = s.length;
  for (var i = 0; i < len; i++) {
    chk += s.charCodeAt(i) * (i + 1);
  }

  return (chk & 0xffffffff).toString(16);
};

export const getColumnId = (column: any) => {
  if (typeof column.field === 'string') {
    if (column.headerName) {
      return `${column.field}:${checksum(column.headerName).substring(0, 8)}`;
    }
    return column.field;
  }

  return checksum(JSON.stringify(column));
};
